import { render, staticRenderFns } from "./CherkizovoCardPartTop.vue?vue&type=template&id=594b7fa4&scoped=true"
import script from "./CherkizovoCardPartTop.vue?vue&type=script&lang=js"
export * from "./CherkizovoCardPartTop.vue?vue&type=script&lang=js"
import style0 from "./CherkizovoCardPartTop.vue?vue&type=style&index=0&id=594b7fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b7fa4",
  null
  
)

export default component.exports